module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_7.91119c98.svg";